module.exports = __webpack_public_path__ + "static/media/预约-其他.85420ef9.svg";